<template>
  <router-view></router-view>
</template>

<script>
import permissionVerificationMinxins from '@/mixins/permission-verification.js'
export default {
  mixins: [permissionVerificationMinxins]
}
</script>

<style>

</style>